import type { IJobTaskTemplate } from '@/interfaces'
import TaskTemplate from './TaskTemplate'

class JobTaskTemplate extends TaskTemplate implements IJobTaskTemplate {
  taskTemplateId: string
  isCompleted: boolean

  constructor(jobTaskTemplate?: any) {
    super(jobTaskTemplate)

    this.taskTemplateId = jobTaskTemplate?.taskTemplateId ?? ''
    this.isCompleted = jobTaskTemplate?.isCompleted ?? false
  }
}

export default JobTaskTemplate
